import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const TriggerRow = styled.div`
  display: flex;
  gap: ${space[2]};
  width: 100%;
`;

export const TriggerButton = styled.button<{ $hasValue: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  padding: 8px 12px;
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: ${colors.primary};
  }
`;

export const TriggerLabel = styled.span`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TriggerValue = styled.span<{ $placeholder?: boolean }>`
  font-size: ${fonts.size.sm};
  color: ${(p) => (p.$placeholder ? colors.grey : colors.fontPrimary)};
`;

export const Dropdown = styled.div<{ $columnView?: boolean; $inline?: boolean }>`
  position: ${({ $inline }) => ($inline ? 'relative' : 'absolute')};
  top: ${({ $inline }) => ($inline ? '0' : 'calc(100% + 4px)')};
  left: ${({ $inline }) => ($inline ? '0' : '50%')};
  transform: ${({ $inline }) => ($inline ? 'none' : 'translateX(-50%)')};
  z-index: 100;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: ${space[4]};
  width: 300px;

  @media (min-width: 660px) {
    width: ${({ $columnView }) => ($columnView ? '300px' : '620px')};
  }
`;

export const NavRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${space[2]};
`;

export const NavButton = styled.button`
  background: none;
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: ${fonts.size.base};
  color: ${colors.fontPrimary};
  transition: background-color 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const MonthsContainer = styled.div<{ $columnView?: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[4]};

  @media (min-width: 660px) {
    grid-template-columns: ${({ $columnView }) => ($columnView ? '1fr' : '1fr 1fr')};
    gap: ${space[5]};
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  border-radius: ${layout.borderRadius};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
`;
